import { useQuery } from '@tanstack/react-query';
import fetch from './fetch';

function useTradelimit() {
  const { cb, key } = fetch();
  const { data, isSuccess, refetch } = useQuery(key, cb);

  /** Funds that are available for trading */
  const buyingPower = data?.trading_limit || 0;

  /**
   * With a given trading limit, what is the maximum possible trading order volume
   * if user decided to spend all of their funds
   * Formula: `trading_limit - max_fee`
   * If `trading_limit` is less than `max_fee`, return 0
   * */
  const usableBuyingPower =
    (data?.trading_limit || 0) > (data?.max_fee || 0)
      ? (data?.trading_limit || 0) - (data?.max_fee || 0)
      : 0;

  return { data, isSuccess, refetch, buyingPower, usableBuyingPower };
}

export default {
  useTradelimit,
};
